// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};